<template>
  <div>
    <div>
      <div>
        <p class="open-sans-20pt">
          Mobilna telefonija
        </p>
      </div>
    </div>
    <div class="postavitev-vsebine-naroci-mobilna">
      <p class="navadno-besedilo">
        Izberite Oranžni mobilni paket po vaši meri in plačujte za tisto, kar potrebujete. Namenjeni so
        vsem, ki radi brezskrbno klepetate po telefonu in pošiljate sporočila.
      </p>
      <p class="navadno-besedilo">
        <b>
          Že od 7,99 € na mesec!
        </b>
      </p>
    </div>
    <div class="postavitev-gumba-naroci-mobilna">
      <a href="https://www.t-2.net/mobilni-paketi">
        <el-button class="gumb-potrdi">
          NAROČI
        </el-button>
      </a>
    </div>
  </div>
</template>

<script>
import { Button } from 'element-ui'

export default {
  name: 'KarticaNarociMobilnoTelefonijo',
  components: {
    [Button.name]: Button
  }
}
</script>

<style scoped>
  .postavitev-gumba-naroci-mobilna {
    margin-top: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Domov/Komponente/KarticaNarociMobilnoTelefonijo.vue